import $ from "jquery";

if (document.querySelector(".stepper2-wrapper-slick")) {

   $('.slider-nav').slick({
     slidesToShow: 1,
     slidesToScroll: 1,
     focusOnSelect: true
   });
  
   $('div[data-slide]').click(function(e) {
     e.preventDefault();
     var slideno = $(this).data('slide');
     $('.slider-nav').slick('slickGoTo', slideno - 1);
/*
    indicators[slideno - 1].style.transitionDelay = "0.6s";
    indicators[slideno - 1].classList.add("completed");
    progressElm.style.width = `${(slideno - 1 / (indicators.length - 1)) * 100}%`;

    $(".active").removeClass("active");
     indicators[slideno - 1].classList.add("active");
     disableControls();*/
   });
  
  
  
let currIndex = 0;

const indicators = document.getElementsByClassName("screen-indicator");
const progressElm = document.getElementsByClassName("progress")[0];
const prevBtn = document.getElementById("prev-btn");
const nextBtn = document.getElementById("next-btn");

disableControls();

  
$( "#prev-btn" ).click(function() {
  // Delay should not be applied when removing class
  indicators[currIndex].style.transitionDelay = "0s";
  indicators[currIndex].classList.remove("completed");
  --currIndex;
  progressElm.style.width = `${(currIndex / (indicators.length - 1)) * 100}%`;
  
  $('.slider-nav').slick('slickGoTo', currIndex);
  
  $(".active").removeClass("active");
  indicators[currIndex].classList.add("active");

  disableControls();
});
  
  $("#next-btn").click(function () {
  
    ++currIndex;
     $('.slider-nav').slick('slickGoTo', currIndex);
    // Delay should be applied when adding class
    indicators[currIndex].style.transitionDelay = "0.6s";
    indicators[currIndex].classList.add("completed");
    progressElm.style.width = `${(currIndex / (indicators.length - 1)) * 100}%`;

    $(".active").removeClass("active");
    indicators[currIndex].classList.add("active");
    disableControls();
});



function disableControls() {
  if (currIndex <= 0) {
    prevBtn.disabled = true;
  } else if (currIndex >= indicators.length - 1) {
    nextBtn.disabled = true;
  } else {
    prevBtn.disabled = false;
    nextBtn.disabled = false;
  }
}


}
